import useHoldings from '@hooks/queries/registry/useHoldings';
import React from 'react';
import { filterHoldingsByInstrument } from '../../utils/filterHoldingsByInstrument';
import { filterHoldingsByOwner } from '../../utils/filterHoldingsByOwner';
import { getMinAmountCids } from '../../utils/getMinAmountCids';

export const MAX_CONTRACT_LIMIT = 1000;
type Args = {
  instrumentId: string;
  registrar: string;
  owner: string;
  amount: string;
};
export const useGetPrepareHoldings = () => {
  const holdings = useHoldings();

  return React.useCallback(
    (args: Args) => {
      const { instrumentId, registrar, amount, owner } = args;
      const instrumentHoldings = filterHoldingsByInstrument({
        instrumentId,
        registrar,
        holdings: holdings.data || [],
      });
      const ownedHoldings = filterHoldingsByOwner({
        owner,
        holdings: instrumentHoldings,
      });
      const holdingCids = getMinAmountCids({
        requiredAmount: amount,
        holdings: ownedHoldings,
      });
      return {
        holdingCids: holdings.isLoading ? [] : holdingCids,
        exceedsMaxLimit: holdingCids.length > MAX_CONTRACT_LIMIT,
      };
    },
    [holdings.data, holdings.isLoading],
  );
};
